import React from "react";
import { formatDateFull } from "../../utils/helper";
export const HighVibrationAlert = ({ item }) => {
  const arr = item.description.split("|");
  const machine = arr[0];
  const location = arr[1];
  const parent_location = arr[2];

  return (
    <div sx={{ fontSize: 12, marginTop: "5px" }}>
      <div className={"row"} container spacing={1}>
        <div className={"col-sm-12"}>
          <b>High Vibration Detected</b>
        </div>
        <div className={"col-sm-4"}>Recorded on</div>
        <div className={"col-sm-1"}>:</div>
        <div className={"col-sm-7"}>{formatDateFull(item.created_at)}</div>

        <div className={"col-sm-4"}>Machine</div>
        <div className={"col-sm-1"}>:</div>
        <div className={"col-sm-7"}>{machine}</div>

        <div className={"col-sm-4"}>Location</div>
        <div className={"col-sm-1"}>:</div>
        <div className={"col-sm-7"}>
          {parent_location} - {location}
        </div>
      </div>
    </div>
  );
};
